//////////////////////////////////////////////////////////////////////////////
//
//  User API
//
//  작성자: MediInStep Team
//  생성일: 2025-01-XX
//
//  설명: 사용자 관련 API 정의
//
//////////////////////////////////////////////////////////////////////////////

import { ApiGroup } from "../types/ApiTypes"

/**
 * 사용자 관련 API
 */
const UserAPI: ApiGroup = {
  pagedList: {
    title: "사용자 목록 조회",
    url: "/User/PagedList",
    method: "POST",
    paramz: {},
  },
  getById: {
    title: "사용자 상세 조회",
    url: "/User/:id",
    method: "GET",
    paramz: {},
    pathParams: ["id"],
  },
  create: {
    title: "사용자 등록",
    url: "/User",
    method: "POST",
    paramz: {},
  },
  update: {
    title: "사용자 정보 수정",
    url: "/User/:id",
    method: "PUT",
    paramz: {},
    pathParams: ["id"],
  },
  getCurrentUser: {
    title: "현재 사용자 정보 조회",
    url: "/User/Me",
    method: "GET",
    paramz: {},
  },
  updateCurrentUser: {
    title: "현재 사용자 정보 수정",
    url: "/User/Me",
    method: "PUT",
    paramz: {},
  },
  getMyActivityStats: {
    title: "내 활동 통계 조회",
    url: "/User/Me/ActivityStats",
    method: "GET",
    paramz: {},
  },
  getMyRecentActivities: {
    title: "최근 활동 로그 조회",
    url: "/User/Me/RecentActivities",
    method: "GET",
    paramz: {},
  },
  changePassword: {
    title: "비밀번호 변경",
    url: "/User/Me/ChangePassword",
    method: "PUT",
    paramz: {},
  },
  getActivityStats: {
    title: "사용자 활동 통계 조회 (관리자용)",
    url: "/User/:id/ActivityStats",
    method: "GET",
    paramz: {},
    pathParams: ["id"],
  },
}

export default UserAPI

